'use strict';

export function init() {
    window.document.addEventListener("keyup", event => {
        if (event.isComposing || event.keyCode === 9) {
            document.body.classList.add("user-is-tabbing");
        }
    });

    window.document.addEventListener("mousedown", () => {
        document.body.classList.remove("user-is-tabbing");
    });
}

export default { init }



// WEBPACK FOOTER //
// ./modules/tabbing.js